/**
 * One collapsible row in a list of message templates: coloured dot, name, and a line saying when
 * that message goes out.
 *
 * Its own module because both the demo Settings view and the real firm's settings use it. It started
 * inside ProfessionalPortalFullWireframeViews, and importing it back out of there created a circular
 * import between the two files — the failure mode that shows up as a Parcel "does not export" error
 * at runtime rather than a type error at build time.
 */
import React, { useState } from 'react';

export interface TemplateAccordionRowProps {
    id: number;
    dotColor: string;
    name: string;
    meta: string;
    defaultOpen?: boolean;
    /** Suppresses the divider under the final row. */
    last?: boolean;
    children?: React.ReactNode;
}

export function TemplateAccordionRow({ id, dotColor, name, meta, defaultOpen = false, last = false, children }: TemplateAccordionRowProps) {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div className="tpl-row" style={last || id === 5 ? { borderBottom: 'none' } : undefined} data-tpl-id={id}>
            <button type="button" className="tpl-hdr" onClick={() => setOpen(!open)} aria-expanded={open}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div className="tpl-dot" style={{ background: dotColor }} />
                    <div>
                        <div className="tpl-name">{name}</div>
                        <div className="tpl-meta">{meta}</div>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span className="tag t-ok" style={{ fontSize: 10 }}>
                        Active
                    </span>
                    <svg
                        viewBox="0 0 24 24"
                        style={{
                            width: 15,
                            height: 15,
                            stroke: 'var(--muted)',
                            fill: 'none',
                            strokeWidth: 2,
                            transform: open ? 'rotate(180deg)' : 'none',
                            transition: 'transform .2s',
                        }}
                    >
                        <polyline points="6 9 12 15 18 9" />
                    </svg>
                </div>
            </button>
            {open && <div className="tpl-body">{children}</div>}
        </div>
    );
}
